(ns frontend.view.login.mfa-setup
  (:require-macros [frontend.macros :refer [without-default-action-and-propagation]])
  (:require [reagent.core :as r]
            [frontend.account :as account]
            [common.localization :as loc]
            [frontend.routing :as routing]
            [frontend.view.login.events :as events]
            [frontend.view.login.components.common :as common]
            [frontend.view.login.db :as db]
            [frontend.bootstrap.components :as rbs]
            [frontend.whitelabelling.utils :as wu]
            [ui.components.button.view :as button]
            [ui.components.alert.view :as alert]))

(defn mfa-setup-view []
  (let [local-state (r/atom {:sign-in-loading false
                             :show-image?     true
                             :show-key?       true})]
    (fn []
      (let [mfa-data (:mfa-setup-data @db/state)
            mfa-error? (:mfa-error? @db/state)
            {:keys [show-image? show-key?]} @local-state
            {:keys [role-id account-id tenant-id tenant-name target-id image-data secret-key]} mfa-data]
        [:div.login-form-section
         [:p (loc/tr :mfa-use-app-and-scan)]
         (if show-image?
           [:div
            [:a.mt-3.login-form-section__link
             {:href     "#"
              :on-click (without-default-action-and-propagation
                          (swap! local-state assoc :show-image? false))}
             (loc/tr :mfa-hide-qr)]
            [:div
             {:class-name "w-[300px] h-[300px] border border-solid border-base-light-border-paler bg-cover"
              :style      {:background-image (str "url(data:image/png;charset=utf-8;base64," image-data ")")}}]]
           [:div
            [:a.login-form-section__link.my-3
             {:href     "#"
              :on-click (without-default-action-and-propagation
                          (swap! local-state assoc :show-image? true))}
             (loc/tr :mfa-show-qr)]
            [:div.mfa-qr.hidden-qr]])
         [:p.pt-2 (loc/tr :mfa-type-secret-key)]
         (if show-key?
           [:div
            [:a.login-form-section__link.py-3
             {:href     "#"
              :on-click (without-default-action-and-propagation
                          (swap! local-state assoc :show-key? false))}
             (loc/tr :mfa-hide-secret-key)]
            [:div.pb-2
             [:strong secret-key]]]
           [:div.py-3
            [:a.login-form-section__link
             {:href     "#"
              :on-click (without-default-action-and-propagation
                          (swap! local-state assoc :show-key? true))}
             (loc/tr :mfa-show-secret-key)]])
         [:div.pt-2 [:p (loc/tr :mfa-type-two-codes)]]

         [rbs/Form
          {:on-submit  (fn [e]
                         (.preventDefault e)
                         (events/set-tenant-with-mfa! target-id account-id role-id tenant-id (or (:mfa-1 @db/state) "1") (or (:mfa-2 @db/state) "1")))
           :class-name "login__left__form mt-3"}
          [common/form-group {:control-id "login-mfa"
                              :label      (str (loc/tr :mfa-code-1) ":")
                              :type       "text"
                              :value      (:mfa-1 @db/state)
                              :on-change! (partial events/on-change! :mfa-1)}]
          [common/form-group {:control-id "login-mfa"
                              :label      (str (loc/tr :mfa-code-2) ":")
                              :type       "text"
                              :value      (:mfa-2 @db/state)
                              :on-change! (partial events/on-change! :mfa-2)}]
          #_[:div (loc/tr :mfa-code-1)
             [auth/mfa-input local-state :mfa-1]]
          #_[:div (loc/tr :mfa-code-2)
             [auth/mfa-input local-state :mfa-2]]
          [:div
           (when mfa-error?
             [alert/danger
              {:on-close    events/hide-mfa-error!}
              (loc/tr :mfa-does-not-match)])]

          [rbs/FormGroup
           [button/primary-solid
            {:type       "submit"
             :block      true
             :class "mt-3"}
            (loc/tr :submit)]]]]))))
